import type { JSX } from 'react';
import type { OsasLifeStyleFormReadData } from '@common/validation/customControls/osas/osasLifestyleFormSchema';
import type { OsaReferralReadData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralReadSchema';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { FormGroupRowAndColsWithFormParagraph } from '@frontend/components/fields/FormGroupRowAndColsWithFormParagraph';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { ProcessActivityReadContext } from '../../../carePath/process/processActivity/processActivityRead/processActivityReadContext';

export function OsasLifeStyleFormRead(): JSX.Element {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getComponents()} />;

    function getComponents(): ComponentsMap {
        const map = new Map();

        const bmiItem = getProcessActivityReadSectionItem<OsasLifeStyleFormReadData>()(
            readSections,
            'weight_length_bmi'
        );

        if (bmiItem?.value) {
            map.set(
                bmiItem.key,
                <FormGroupRowAndColsWithFormParagraph
                    label={bmiItem.label}
                    values={bmiItem.value}
                />
            );
        }
        const alcoholConsumptionItem = getProcessActivityReadSectionItem<OsasLifeStyleFormReadData>()(
            readSections,
            'alcoholConsumption'
        );

        if (alcoholConsumptionItem?.value) {
            map.set(
                alcoholConsumptionItem.key,
                <FormGroupRowAndColsWithFormParagraph
                    label={alcoholConsumptionItem.label}
                    values={alcoholConsumptionItem.value}
                />
            );
        }

        const smokingItem = getProcessActivityReadSectionItem<OsaReferralReadData>()(readSections, 'years_packs');

        if (smokingItem?.value) {
            map.set(
                smokingItem.key,
                <FormGroupRowAndColsWithFormParagraph
                    label={smokingItem.label}
                    values={smokingItem.value}
                />
            );
        }

        return map;
    }
}
